<template>
  <Can action="store" subject="contract">
    <div data-component-group="contract-dialog" data-component="add-new">
      <dialog-add
        icon="receipt"
        :title="$t('add_new_contract')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-contract-add-new
            :contract="{}"
            class="elevation-1"
            :is-loading="isAddingContract"
            :on-cancel="onCancel"
            :on-submit="createContract"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isAddingContract: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'contracts', query: this.$route.query });
      },
      createContract(contract) {
        this.isAddingContract = true;

        return this.$store
          .dispatch('contracts/create', contract)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'contracts', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingContract = false;
          });
      },
    },
  };
</script>
